<template>
  <v-chip
    v-if="!showTooltip"
    filter
    :color="color"
    :value="value"
  >
    {{ text }}
  </v-chip>

  <v-tooltip
    v-else
    top
    :color="color"
  >
    <template #activator="{ on, attrs}">
      <v-chip
        v-if="text !== null"
        v-bind="attrs"
        class="ma-0"
        filter
        :color="color"
        :value="value"
        v-on="on"
      >
        {{ text }}
      </v-chip>

      <div
        v-else
        :style="divStyle"
        v-bind="attrs"
        v-on="on"
      />
    </template>

    <span v-if="!tooltipText2">{{ tooltipText }}</span>

    <p v-else>
      {{ tooltipText }}
    </p>

    <span>{{ tooltipText2 }}</span>
  </v-tooltip>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  props: {
    showTooltip: Boolean,
    tooltipText: {
      type: String,
      default: null,
    },
    tooltipText2: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    value: {
      type: Number,
      default: null,
    },
    color: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const divStyle = computed(() => `
      min-width: 20px;
      min-height: 20px;
      max-width: 20px;
      max-height: 20px;
      border-radius: 50%;  
      background-color: ${props.color};
    `)

    return {
      divStyle,
    }
  },
}
</script>
